<template>
  <div class="container mt-4" dir="rtl">
    
    <!-- ========================================== -->
    <!-- 1. لوحة التحكم والبحث (تختفي عند الطباعة) -->
    <!-- ========================================== -->
    <div class="card no-print mb-4 shadow-sm border-top-primary">
      <div class="card-header bg-white">
        <h5 class="fw-bold text-primary mb-0">
          <i class="fas fa-print ms-2"></i> طباعة خطابات التكليف وبيانات الدخول
        </h5>
      </div>
      <div class="card-body">
        <div class="row align-items-end g-3">
          
          <!-- فلتر اختيار اللجنة -->
          <div class="col-md-6">
            <label class="fw-bold mb-2">اختر اللجنة لطباعة الخطاب</label>
            <select v-model="selectedCommitteeId" class="form-select" @change="fetchChairmanData">
              <option value="" disabled>-- اختر اللجنة من القائمة --</option>
              <option v-for="c in committeesList" :key="c.id" :value="c.id">
                {{ c.committee_no }} - {{ c.commitee_name }}
              </option>
            </select>
          </div>

          <!-- أزرار التحكم -->
          <div class="col-md-6 d-flex gap-2">
            <button @click="fetchChairmanData" class="btn btn-primary px-4 fw-bold" :disabled="!selectedCommitteeId || loading">
               <span v-if="loading" class="spinner-border spinner-border-sm ms-1"></span>
               <span v-else><i class="fas fa-search ms-2"></i> عرض البيانات</span>
            </button>
            
            <button @click="print" class="btn btn-dark px-4 fw-bold" :disabled="!chairman">
                <i class="fas fa-print ms-2"></i> طباعة الخطاب
            </button>
          </div>

        </div>
      </div>
    </div>

    <!-- ========================================== -->
    <!-- 2. ورقة الطباعة (تظهر فقط عند وجود بيانات) -->
    <!-- ========================================== -->
    <div id="printMe" v-if="chairman" class="print-area" >
      <div class="official-paper" dir="rtl">
        
        <!-- أ. الترويسة الرسمية -->
        <div class="header-section text-center mb-4" >
            <div class="row align-items-center">
                <div class="col-3 text-center">
                    <h6 class="fw-bold mb-1">محافظة شمال سيناء</h6>
                    <h6 class="fw-bold mb-0">مديرية التربية والتعليم</h6>
                    <h6 class="fw-bold mb-0">  لجنة النظام والمراقبة</h6>
                </div>
                <div class="col-6">
                    <!-- تأكد من وجود اللوجو في المسار الصحيح -->
                    <img src="/img/logo/edu.png" alt="logo" class="logo-img mb-2" style="height: 70px;">
                    <h4 class="fw-bold text-decoration-underline text-primary-dark">بيانات حساب رئيس لجنة سير امتحان</h4>
                    <h6 class="fw-bold mt-1 zzz-20">الشهادة الإعدادية - للعام الدراسي 2026</h6>
                </div>
                <div class="col-3 text-start">
                    <div class="qr-box text-center">
                        <qrcode-vue 
                            :value="generateQrData" 
                            :size="100" 
                            level="H" 
                            render-as="svg"
                        ></qrcode-vue>
                        <p class="small mt-1 mb-0 fw-bold">Scan Me</p>
                    </div>
                </div>
            </div>
            <hr class="header-line">
        </div>

        <!-- ب. بيانات التكليف -->
        <div class="welcome-box mb-4 p-3 bg-light rounded border">
            <div class="row align-items-center">
                <div class="col-8">
                    <h5 class="fw-bold text-dark mb-3">
                        السيد الأستاذ / <span class="text-primary-dark border-bottom border-dark px-3">{{ chairman.name }}</span>
                    </h5>
                    <p class="mb-0 fw-bold fs-5">
                        رئيس لجنة: <span class="bg-white px-3 py-1 border rounded shadow-sm">{{ chairman.committee_name }}</span>
                    </p>
                </div>
                <div class="col-4 text-start">
                    <div class="border border-dark p-2 text-center rounded bg-white shadow-sm">
                        <small class="fw-bold d-block text-muted">رقم اللجنة</small>
                        <strong class="fs-2 font-monospace">{{ chairman.committee_no }}</strong>
                    </div>
                </div>
            </div>
        </div>

        <!-- ج. كارت بيانات الدخول (الجزء الأهم) -->
        <div class="credentials-card p-4 mb-5">
            <div class="credentials-header text-center mb-4">
                <span class="bg-dark text-white px-4 py-2 rounded-pill fw-bold shadow-sm">
                    <i class="fas fa-key ms-2 text-warning"></i> بيانات الدخول للمنظومة
                </span>
            </div>
            
            <div class="row text-center">
                <div class="col-6 border-start border-2">
                    <p class="text-muted mb-1 fw-bold small">اسم المستخدم (User Name)</p>
                    <h3 class="fw-bold font-monospace text-primary-dark tracking-wide">{{ chairman.username }}</h3>
                </div>
                <div class="col-6">
                    <p class="text-muted mb-1 fw-bold small">كلمة المرور (Password)</p>
                    <h3 class="fw-bold font-monospace text-danger tracking-wide">{{ chairman.password }}</h3>
                </div>
            </div>
            
            <div class="text-center mt-4 pt-2 border-top">
                <p class="mb-0 fw-bold">رابط الدخول: <span class="font-monospace text-primary text-decoration-underline">https://control.sinai-edu.com</span></p>
            </div>
        </div>

        <!-- د. خطوات العمل (الدليل) -->
       <div class="instructions-section mb-4">
    <h5 class="section-title fw-bold mb-3 border-bottom pb-2 d-inline-block">
        <i class="fas fa-list-ol ms-2 text-gold"></i> خطوات العمل على المنظومة:
    </h5>
    
    <ul class="steps-list">
        <!-- خطوة 1 -->
        <li>
            <span class="step-num">1</span>
            <div class="step-content">
                <strong>تسجيل الدخول:</strong>
                <p>الدخول على الرابط أعلاه، وإدخال البيانات الموضحة، ثم الضغط على "دخول".</p>
            </div>
        </li>

        <!-- خطوة 2 -->
        <li>
            <span class="step-num">2</span>
            <div class="step-content">
                <strong>تحميل بيانات الطلاب:</strong>
                <p>من القائمة الجانبية اختر <u>"بيانات اللجنة"</u> ثم اضغط زر <span class="badge bg-success text-white">تحميل ملف الإكسيل</span> للحصول على كشف بأسماء وأرقام جلوس الطلاب.</p>
            </div>
        </li>

        <!-- خطوة 3 (الجديدة) -->
        <li>
            <span class="step-num">3</span>
            <div class="step-content">
                <strong>تسجيل الغياب:</strong>
                <p>يتم الدخول يومياً على صفحة <u>"تسجيل الغياب"</u>، واختيار المادة، ثم تحديد الطلاب الغائبين والضغط على <strong>حفظ</strong> لترحيل البيانات للكنترول فورياً.</p>
            </div>
        </li>

        <!-- خطوة 4 (تم ترحيلها) -->
        <li>
            <span class="step-num">4</span>
            <div class="step-content">
                <strong>التواصل والبلاغات:</strong>
                <p>لمتابعة التعليمات اليومية أو إرسال شكوى فورية للكنترول، استخدم صفحة <u>"غرفة عمليات اللجنة"</u>.</p>
            </div>
        </li>
    </ul>
</div>

        <!-- هـ. التذييل -->
        <div class="footer-note mt-auto pt-3 border-top border-2 border-dark">
            <div class="row align-items-center">
                <div class="col-7">
                    <p class="small fw-bold mb-1"><i class="fas fa-headset ms-1"></i>   للدعم الفني: 01080408330⁩</p>
                    <p class="small text-danger fw-bold mb-0">
                        <i class="fas fa-lock ms-1"></i> تنبيه: هذه البيانات سرية للغاية وهي عهدة شخصية على السيد رئيس اللجنة.
                    </p>
                </div>
                <div class="col-5 text-center">
                    <h6 class="fw-bold mb-3">رئيس لجنة النظام والمراقبة</h6>
                    <p>.......................................</p>
                </div>
            </div>
        </div>

      </div>
    </div>
    
    <!-- رسالة تظهر عند فتح الصفحة لأول مرة -->
    <div v-else-if="!loading" class="alert alert-info text-center mt-5 no-print shadow-sm">
        <i class="fas fa-info-circle fa-lg mb-2 d-block"></i>
        يرجى اختيار اللجنة من القائمة في الأعلى لعرض وطباعة خطاب التكليف.
    </div>

  </div>
</template>

<script>
import api from '@/api/axios';
import QrcodeVue from 'qrcode.vue';
export default {
     components: {
    QrcodeVue,
  },
  name: "ChairmanLoginSheet",
  data() {
    return {
      loading: false,
      committeesList: [], // قائمة اللجان للملء
      selectedCommitteeId: "",
      chairman: null, // بيانات الرئيس المختار للعرض
    };
  },
   computed: {
    // 3. توليد محتوى الـ QR
    generateQrData() {
        if (!this.chairman) return "";
        
        // هذا الرابط سيقوم بفتح صفحة الدخول وملء اسم المستخدم تلقائياً
        // مثال: https://mysite.com/login?u=COMM_105
        const baseUrl = 'https://control.sinai-edu.com'; 
        return `${baseUrl}/login`;
        // return `${baseUrl}/login?u=${this.chairman.username}`;
    }
  },
  mounted() {
    this.fetchCommitteesList();
  },
  methods: {
    // 1. جلب قائمة اللجان للـ Select
    async fetchCommitteesList() {
        try {
            // تأكد من صحة الرابط في الباك إند
            const res = await api.get('/admin/getCommittee'); 
            this.committeesList = res.data;
        } catch(e) { 
            console.error("Error fetching committees", e); 
        }
    },

    // 2. جلب بيانات الرئيس بناءً على اللجنة المختارة
    async fetchChairmanData() {
        if(!this.selectedCommitteeId) return;
        
        this.loading = true;
        this.chairman = null; // تصفير البيانات القديمة

        try {
            const res = await api.get('/admin/chairman-credentials', {
                params: { committee_id: this.selectedCommitteeId }
            });
            this.chairman = res.data;
        } catch(e) {
            alert("لم يتم العثور على بيانات دخول لرئيس هذه اللجنة، تأكد من إنشاء المستخدم.");
        } finally {
            this.loading = false;
        }
    },

    // 3. الطباعة
    print() {
        this.$htmlToPaper("printMe");
    }
  }
};
</script>

<style scoped>
/* استيراد الخط العربي */
/* @import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;600;700;900&display=swap'); */

/* تنسيقات عامة */
.border-top-primary { border-top: 4px solid #0d6efd; }
.text-gold { color: #d4a017; }
.text-primary-dark { color: #002147; }
.tracking-wide { letter-spacing: 1px; }

/* =========================================
   تنسيقات الطباعة (A4)
   ========================================= */
@media print {
    @page {
        size: A4 portrait;
        margin: 10mm;
    }
    
    body { 
        background-color: white; 
        font-family: 'Cairo', sans-serif; 
        -webkit-print-color-adjust: exact; 
        print-color-adjust: exact;
    }

    .no-print { display: none !important; }
    
    #printMe { visibility: visible; }
    #printMe { width: 100%; height: 100%; }

    /* الورقة الرسمية */
    .official-paper {
        border: 4px double #000; /* إطار مزدوج */
        padding: 20px;
        min-height: 275mm; /* ارتفاع A4 تقريباً */
        position: relative;
        display: flex;
        flex-direction: column;
        background-image: url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='%23000000' fill-opacity='0.03' fill-rule='evenodd'/%3E%3C/svg%3E");
    }

    .header-line {
        border-top: 3px solid #000;
        opacity: 1;
        margin-top: 10px;
    }

    /* كارت البيانات */
    .credentials-card {
        border: 2px dashed #002147;
        background-color: #f8f9fa !important;
        border-radius: 15px;
    }

    /* القوائم */
    .steps-list {
        list-style: none;
        padding: 0;
    }
    .steps-list li {
        display: flex;
        align-items: flex-start;
        margin-bottom: 12px;
    }
    .step-num {
        background-color: #000 !important;
        color: #fff !important;
        width: 28px;
        height: 28px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        margin-left: 10px;
        flex-shrink: 0;
    }
    .step-content strong {
        display: block;
        font-size: 1.05rem;
        text-decoration: underline;
    }
    .step-content p {
        margin: 0;
        color: #333;
        font-size: 0.95rem;
    }

    /* التأكيد على ظهور الألوان */
    .bg-dark { background-color: #000 !important; color: #fff !important; }
    .bg-light { background-color: #eee !important; }
    .text-danger { color: #dc3545 !important; }
    .text-primary-dark { color: #002147 !important; }
}
</style>